import { schema as schemas } from 'normalizr'

import { CallApi } from '@signavio/kraken'

export const collection = 'workflowImports'

export const schema = new schemas.Entity(collection, undefined, {
  idAttribute: ({ editorWorkflow }) => editorWorkflow.id,
})

export const create =
  (callApi: CallApi, apiBase: string) => (_: unknown, fileId: string) =>
    callApi(`${apiBase}/workflows/import/bpmn/${fileId}`, schema, {
      method: 'POST',
    })
